"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const identifiers_1 = require("../identifiers");
class WrappedContent {
    constructor(data) {
        this.data = data;
        this.setContentType(data);
    }
    setContentType(data) {
        // set content type of json based on key check in object
        if (data.contentType) {
            this._contentType = data.contentType;
        }
        else {
            console.error('unidentified content type. Setting default content type as question');
            this._contentType = identifiers_1.Types.ContentTypes.QUESTION;
        }
    }
    getItems() {
        switch (this._contentType) {
            case identifiers_1.Types.ContentTypes.PROGRAM:
                const items = [];
                for (const activity of this.data) {
                    items.push(Object.assign({}, activity.items, { activityId: this.data.activityId }));
                }
                return items;
            case identifiers_1.Types.ContentTypes.ACTIVITY:
                return this.data.items;
            case identifiers_1.Types.ContentTypes.ITEM:
                return [this.data];
            default:
                return [];
        }
    }
    getActivities() {
        switch (this._contentType) {
            case identifiers_1.Types.ContentTypes.PROGRAM:
                return this.data.activities;
            case identifiers_1.Types.ContentTypes.ACTIVITY:
                return [this.data];
            default:
                return [];
        }
    }
    getPrograms() {
        switch (this._contentType) {
            case identifiers_1.Types.ContentTypes.PROGRAM:
                return [this.data];
            default:
                return [];
        }
    }
}
exports.default = WrappedContent;
//# sourceMappingURL=WrappedContent.js.map